import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarkunreadMailboxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"markunread_mailbox"}/>
}
